import React, {Component} from 'react';
import Title from '../base/title';
import api from '../../utils/api';
import {InfoBox, GoogleMap, Marker, StyledMapWithAnInfoBox} from '../base/map';

let toFloat = (number) => {
    return number ? parseFloat(number).toFixed(2) : parseFloat(0).toFixed(2);
};

export default class Prices extends Component {

    constructor(props) {
        super(props);
        this.brands = ["ypf", "axion", "petrobras", "shell"];
        this.state = {
            loader: ' loader-box',
            currentBoca: {
                stations: []
            },
            showInfoBox: true,
            currentCenter: {},
            currentStation: '',
            loadMap: false,
            prices: {
                'last_24_hours': [],
                'last_week': [],
                'last_month': []
            },
            currentMarker: {}
        };
        this.mapRender = this.mapRender.bind(this);
        this.analyzeCluster = this.analyzeCluster.bind(this);
    }

    mapRender(props) {
        let _self = this;
        let boca = this.state.currentBoca;
        if (props.loadMap)
            return <GoogleMap defaultOptions={{styles: props.myStyle}} defaultZoom={8} defaultCenter={{
                lat: Object.keys(_self.state.currentCenter).length > 0 ? _self.state.currentCenter.lat : (props.bocas['last_month'].length ? props.bocas['last_month'][1].stations[0].coords[1] : props.center.lat),
                lng: Object.keys(_self.state.currentCenter).length > 0 ? _self.state.currentCenter.lng : (props.bocas && props.bocas['last_month'].length ? props.bocas['last_month'][1].stations[0].coords[0] : props.center.lng)
            }}>
                {
                    boca.stations.map((station, index) => {
                        return <Marker key={station.coords[0]}
                                       icon={{url: api.marker(station.brand ? station.brand.map_marker : true)}}
                                       position={{lat: station.coords[1], lng: station.coords[0]}} onClick={() => {
                            _self.setState({currentMarker: station});
                        }}>
                            {_self.state.currentMarker.coords && _self.state.currentMarker.coords[0] === station.coords[0] &&
                            <InfoBox onCloseClick={() => {
                                _self.setState({currentMarker: {}});
                            }} options={{closeBoxURL: ``, enableEventPropagation: true}}>
                                <div className="info-box">
                                    <h2>{station.brand.name.toLowerCase().includes('shell') ? ('Shell ' + station.global_code + ' (' + station.inscription_number + ')') : station.brand.name + " " + station.inscription_number}<span
                                        onClick={() => {
                                            _self.setState({currentMarker: {}});
                                        }}>X</span></h2>
                                    <p>{station.address}</p>
                                    <table>
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Precio ($)</th>
                                            <th>Aumento (%)</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {station.prices.map(price => {
                                            return <tr key={price.product_shortname}>
                                                <td><b>{price.product_shortname}</b></td>
                                                <td>{toFloat(price.pvp)}</td>
                                                <td>{toFloat(price.diff_pvp_vs_previous_pvp)}</td>
                                            </tr>
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </InfoBox>
                            }
                        </Marker>
                    })
                }
            </GoogleMap>;
        else
            return <div></div>
    }

    componentDidMount() {
        let _self = this;

        api.get("dashboard/activity/").then(prices => {
            let _prices = _self.state.prices;

            Object.keys(prices.data).forEach(period => {
                prices.data[period].forEach(el => {
                    let brand = el.brand.name.split(" ")[0].toLowerCase();
                    if (_self.brands.indexOf(brand) !== -1) {
                        let obj = {
                            id: el.cluster.id,
                            brand: brand,
                            bocas: 0,
                            bocasPM: 0,
                            section: '',
                            stations: [],
                            period: period
                        };

                        el.stations.forEach(station => {
                            if (station.is_prime_marker) {
                                obj.bocasPM++;
                            }

                            let coords = JSON.parse(station.coord_geojson);
                            let s = {
                                coords: coords.coordinates,
                                prices: station.last_prices
                            };

                            s.brand = el.brand;
                            s.global_code = station.global_code;
                            s.inscription_number = station.inscription_number;
                            s.address = station.address;

                            obj.stations.push(s);
                        });

                        obj.bocas = el.updated_stations + "/" + el.total_stations;
                        obj.bocasPM = obj.bocasPM + "/" + el.total_stations;
                        obj.section = el.cluster.name;

                        _prices[period].push(obj);
                    }
                });
            });

            let data = false;
            if (_prices['last_month'] && _prices['last_month'].length) data = _prices['last_month'][0];
            if (_prices['last_week'] && _prices['last_week'].length) data = _prices['last_week'][0];
            if (_prices['last_24_hours'] && _prices['last_24_hours'].length) data = _prices['last_24_hours'][0];

            _self.setState({
                currentBoca: data,
                currentStation: data.brand,
                currentCenter: {
                    lat: data.stations[0].coords[1],
                    lng: data.stations[0].coords[0]
                },
                prices: _prices,
                loadMap: true,
                loader: ''
            });
        })
    }

    analyzeCluster(id) {
        window.location = '/analisis/cluster/' + id;
    }

    render() {
        let _self = this;
        return <div className="dashboard_precios">
            <Title text="ACTUALIZACIONES DE PRECIOS"/>
            <div className="row">
                <div className="col s12">
                    <div className="row">
                        <div className={"dashboard_precios_content" + this.state.loader}>
                            <div className="row">
                                <div className="col l6">
                                    <div className="dashboard_precios_content_data col l12">
                                        <span className="dashboard_precios_content_period">ÚLTIMAS 24 HS</span>
                                        {_self.state.prices['last_24_hours'].map((data, i) => {
                                            return <button key={i}
                                                           className={"dashboard_precios_content_single" + ((_self.state.currentBoca.id + _self.state.currentBoca.brand + _self.state.currentBoca.period) === (data.id + data.brand + data.period) ? ' active' : '')}
                                                           onClick={() => {
                                                               _self.setState({loadMap: false}, function () {
                                                                   _self.setState({
                                                                       currentBoca: data,
                                                                       currentStation: data.brand,
                                                                       showInfoBox: true,
                                                                       loadMap: true,
                                                                       currentCenter: {
                                                                           lat: data.stations[0].coords[1],
                                                                           lng: data.stations[0].coords[0]
                                                                       }
                                                                   })
                                                               });
                                                           }}>
                                                <div className="row">
                                                    <div className="col s4">
                                                        <span className={"company " + data.brand}>● {data.brand}</span>
                                                    </div>
                                                    <div className="col s3">
                                                        <span className="pumps">{data.bocas} <span>Bocas</span></span>
                                                    </div>
                                                    <div className="col s4">
                                                        <span className="location">{data.section}</span>
                                                    </div>
                                                    <div className="arrow-right">
                                                        <img alt="" src="/static/imgs/arrow-right.svg"/>
                                                    </div>
                                                </div>
                                            </button>
                                        })
                                        }
                                        <span className="dashboard_precios_content_period">ÚLTIMA SEMANA</span>
                                        {_self.state.prices['last_week'].map((data, i) => {
                                            return <button key={i}
                                                           className={"dashboard_precios_content_single" + ((_self.state.currentBoca.id + _self.state.currentBoca.brand + _self.state.currentBoca.period) === (data.id + data.brand + data.period) ? ' active' : '')}
                                                           onClick={() => {
                                                               _self.setState({loadMap: false}, function () {
                                                                   _self.setState({
                                                                       currentBoca: data,
                                                                       currentStation: data.brand,
                                                                       showInfoBox: true,
                                                                       loadMap: true,
                                                                       currentCenter: {
                                                                           lat: data.stations[0].coords[1],
                                                                           lng: data.stations[0].coords[0]
                                                                       }
                                                                   })
                                                               });
                                                           }}>
                                                <div className="row">
                                                    <div className="col s4">
                                                        <span className={"company " + data.brand}>● {data.brand}</span>
                                                    </div>
                                                    <div className="col s3">
                                                        <span className="pumps">{data.bocas} <span>Bocas</span></span>
                                                    </div>
                                                    <div className="col s4">
                                                        <span className="location">{data.section}</span>
                                                    </div>
                                                    <div className="arrow-right">
                                                        <img alt="" src="/static/imgs/arrow-right.svg"/>
                                                    </div>
                                                </div>
                                            </button>
                                        })
                                        }
                                        <span className="dashboard_precios_content_period">ÚLTIMO MES</span>
                                        {_self.state.prices['last_month'].map((data, i) => {
                                            return <button key={i}
                                                           className={"dashboard_precios_content_single" + ((_self.state.currentBoca.id + _self.state.currentBoca.brand + _self.state.currentBoca.period) === (data.id + data.brand + data.period) ? ' active' : '')}
                                                           onClick={() => {
                                                               _self.setState({loadMap: false}, function () {
                                                                   _self.setState({
                                                                       currentBoca: data,
                                                                       currentStation: data.brand,
                                                                       showInfoBox: true,
                                                                       loadMap: true,
                                                                       currentCenter: {
                                                                           lat: data.stations[0].coords[1],
                                                                           lng: data.stations[0].coords[0]
                                                                       }
                                                                   })
                                                               });
                                                           }}>
                                                <div className="row">
                                                    <div className="col s4">
                                                        <span className={"company " + data.brand}>● {data.brand}</span>
                                                    </div>
                                                    <div className="col s3">
                                                        <span className="pumps">{data.bocas} <span>Bocas</span></span>
                                                    </div>
                                                    <div className="col s4">
                                                        <span className="location">{data.section}</span>
                                                    </div>
                                                    <div className="arrow-right">
                                                        <img alt="" src="/static/imgs/arrow-right.svg"/>
                                                    </div>
                                                </div>
                                            </button>
                                        })
                                        }
                                    </div>
                                </div>
                                <div className="col l6 no-padding-right">
                                    <div className="dashboard_precios_content_map pumps">
                                        <StyledMapWithAnInfoBox currentMarker={_self.state.currentMarker}
                                                                renderMethod={_self.mapRender}
                                                                loadMap={_self.state.loadMap} bocas={_self.state.prices}
                                                                currentCenter={_self.state.currentCenter}/>

                                        {!this.state.currentMarker.coords &&
                                        <div
                                            className={"dashboard_precios_content_map_boca" + (_self.state.currentBoca.bocas && _self.state.showInfoBox ? '' : ' hide')}>
                                            <table>
                                                <thead>
                                                <tr>
                                                    <th>{_self.state.currentBoca.section}</th>
                                                    <th><span onClick={() => {
                                                        _self.analyzeCluster(_self.state.currentBoca.id)
                                                    }}>ANALIZAR CLUSTER</span></th>
                                                    <th><span onClick={() => {
                                                        _self.setState({showInfoBox: false})
                                                    }}>X</span></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>{_self.state.currentStation}</td>
                                                    <td>{_self.state.currentBoca.bocas} BOCAS ACTUALIZADAS</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>{_self.state.currentBoca.bocasPM} BOCAS ACTUALIZADAS SON PM</td>
                                                    <td><span onClick={() => {
                                                        _self.props.openDesvio(_self.state.currentBoca.id)
                                                    }}>VER DESVIOS</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/containers/dashboard/prices.js